import { BaseFileFiledDto } from '@diritto/common/base/base.dto';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ProfileImage } from 'app-components/accounts/profiles/ProfileImage';
import { getTextLineStyle } from 'styles/common';

export interface ProfileMenuItemProps {
  className?: string;
  nickname?: string;
  size?: number;
  file?: BaseFileFiledDto;
  fontWeight?: number;
  children?: React.ReactNode;
  inboxCount?: number;
  onClick?: () => void;
}

export const ProfileMenuItem = ({
  className,
  nickname,
  file,
  size,
  fontWeight,
  inboxCount = 0,
  onClick,
  children,
}: ProfileMenuItemProps) => (
  <StyledWrapper className={className} fontWeight={fontWeight} onClick={onClick}>
    {inboxCount > 0 && <StyledMark />}
    <ProfileImage file={file} defaultImageKey={nickname} size={size} />
    <p>{nickname}</p>
    {children}
  </StyledWrapper>
);

const StyledWrapper = styled.div(
  ({ fontWeight }: ProfileMenuItemProps) => css`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    padding: 12px 16px;
    position: relative;

    & > p {
      margin-left: 8px;
      font-weight: ${fontWeight || FontWeight.Medium};
      ${Typography.XXSmall};
      ${getTextLineStyle()};
      flex: 1;
    }

    &:hover {
      background-color: ${Color.Primary100};
    }
  `,
);

const StyledMark = styled.div`
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${Color.Red500};
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
`;
